import * as $                                         from 'jquery';
import {onLoad} from "Core/Events";

export const ToolTip = (() => {

    const Selector = {
        TOOLTIP                   : '[data-toggle="tooltip"]:not(.js_product_card_tooltip)',
        TOOLTIP_PRODUCT_CARD      : '.js_product_card_tooltip[data-toggle="tooltip"]'
    };

    onLoad(disableToolTipOnTouchScreen);
    onLoad(tooltipInit);

    function tooltipInit() {
        //Typical default tooltip
        $(Selector.TOOLTIP).tooltip();

        // Tooltip only for display info on product card for lowest price 
        $(Selector.TOOLTIP_PRODUCT_CARD).tooltip( {
            template: '<div class="tooltip tooltip-lowest-price" role="tooltip"><div class="tooltip-inner"></div></div>'
        })
    }

    function disableToolTipOnTouchScreen() {
        if(('ontouchstart' in window))
        { 
            $(Selector.TOOLTIP).tooltip('disable'); // <-- Example code from Bootstrap docs
        }
    }

})();import * as $                                         from 'jquery';
import {onLoad} from "Core/Events";

export const ToolTip = (() => {

    const Selector = {
        TOOLTIP                   : '[data-toggle="tooltip"]:not(.js_product_card_tooltip)',
        TOOLTIP_PRODUCT_CARD      : '.js_product_card_tooltip[data-toggle="tooltip"]'
    };

    onLoad(disableToolTipOnTouchScreen);
    onLoad(tooltipInit);

    function tooltipInit() {
        //Typical default tooltip
        $(Selector.TOOLTIP).tooltip();

        // Tooltip only for display info on product card for lowest price 
        $(Selector.TOOLTIP_PRODUCT_CARD).tooltip( {
            template: '<div class="tooltip tooltip-lowest-price" role="tooltip"><div class="tooltip-inner"></div></div>'
        })
    }

    function disableToolTipOnTouchScreen() {
        if(('ontouchstart' in window))
        { 
            $(Selector.TOOLTIP).tooltip('disable'); // <-- Example code from Bootstrap docs
        }
    }

})();